export const getAppUrl = () =>
  window.location.port
    ? window.location.hostname + ':' + window.location.port
    : window.location.hostname;
